module.exports = __webpack_public_path__ + "static/img/SA.07b0e0e2.jpg";